import type {User} from "@/src/modules/users/types";

import type {OnGuardAssigneeRef} from "../types";

export function getAssigneeDisplayName(assignee: OnGuardAssigneeRef): string {
  return assignee.name.trim() || "—";
}

/** Minimal User stub for UsersCombobox when editing an existing roster row. */
export function assigneeRefToUserStub(assignee: OnGuardAssigneeRef): User {
  const parts = assignee.name.trim().split(/\s+/);
  const first_name = parts[0] ?? "";
  const last_name = parts.slice(1).join(" ");

  return {
    user_id: assignee.id,
    first_name,
    last_name,
    user_name: assignee.name,
    email: "",
    telephone: assignee.telephone ?? "",
    created_at: "",
    updated_at: "",
    email_verified_at: null,
    last_login_date: null,
    status: 1,
    house_hold: {id: 0, name: ""},
    properties: [],
    role: null,
  };
}
